import { render, staticRenderFns } from "./UpdatedeptRight.vue?vue&type=template&id=0132c317&scoped=true"
import script from "./UpdatedeptRight.vue?vue&type=script&lang=js"
export * from "./UpdatedeptRight.vue?vue&type=script&lang=js"
import style0 from "./UpdatedeptRight.vue?vue&type=style&index=0&id=0132c317&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132c317",
  null
  
)

export default component.exports